import { formatIconImg, formatImgZoom, formatTags } from './formatters';
import { formatZoomAttr } from './formatters/attributes';
import { RPGLink, RPGTypes } from './formatters/types';
import type { Options, PokerGameTile, ZoomType } from './types';
import { ePoolBlockGameTypeCollection } from './types';

const mapZoomType = (
  {
    staticData: {
      id,
      clubId,
      currency,
      minChipsLimit,
      game,
      ante,
      cap,
      maxBuyIn,
      maxPlayersPerTable,
      server,
      serverObj,
      structure,
      isPlayMoney,
      scalePM,
      tableStakes: { blinds, stakes },
      isOneOnOne,
      loBet,
      hiBet,
      isHiLo
    },
    lastEntry
  }: ZoomType,
  { language }: Options
): PokerGameTile => ({
  id,
  clubId,
  type: RPGTypes.CASH_GAME,
  link: RPGLink.ZOOM,
  imageUrl: formatImgZoom(game, structure, maxBuyIn, isOneOnOne),
  imageUrlV2: formatImgZoom(game, structure, maxBuyIn, isOneOnOne, true),
  tags: formatTags({ game, structure, maxPerTable: maxPlayersPerTable, ante, cap, isHiLo }),
  attributes: formatZoomAttr(
    {
      minChipsLimit,
      maxBuyIn,
      blinds,
      currency,
      isPlayMoney,
      game,
      stakes,
      ante,
      structure,
      scalePM,
      loBet,
      hiBet
    },
    language
  ),
  lastEntry,
  iconUrl: formatIconImg(RPGTypes.CASH_GAME),
  server,
  serverObj,
  ePoolBlockGameType: ePoolBlockGameTypeCollection.zoomType,
  isPlayMoney: Boolean(isPlayMoney) // isPlayMoney could be a number (0/1)
});

const mapZoomTypesFn = (zoomTypes: ZoomType[], options: Options): PokerGameTile[] =>
  zoomTypes.map((type: ZoomType) => mapZoomType(type, options));

export default mapZoomTypesFn;
